/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import {
  Box,
  Flex,
  FormControl,
  Grid,
  Link,
  ListItem,
  Radio,
  RadioGroup,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import parser from 'html-react-parser';
import { nanoid } from 'nanoid';
import { useRouter } from 'next/router';

/* Internal Imports */
/* Components */
import SingleImage from '@components/Card/SingleImage';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import { useEOEContext } from '@store/EOEContext';
import config from '@config';

/* Services */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
/**
 *
 * @param {object} section
 * @returns ProgramDetails
 */
export const pageCss = {
  en: {
    tabTitle: {
      fontSize: {
        base: '16px',
        md: '22px',
      },
      color: 'red',
    },
    testimonialHeight: 571,
    cardTitle: {
      lineHeight: {
        base: '1.5rem',
        md: '1.6rem',
      },
    },
  },
};

const FourCardsToronto = ({ section, region, lang, selTab, selCity }) => {
  const sectionContent = section?.sectionContent;
  const [IESelectedProg, setIESelectedProg] = useState('Online');

  const [noUrl, setNoUrl] = useState('');
  const [yesUrl, setYesUrl] = useState('');
  const [selectedProg, setSelectedProg] = useState(null);
  const { isIeDone } = useEOEContext();
  const router = useRouter();
  const torontoUrl = selCity === 'Toronto';

  const handleIEProgramRadio = (event, data) => {
    event.preventDefault();
    setIESelectedProg(data.type);
    emptySelection();
  };

  const handleRadioClick = (event, data) => {
    event.preventDefault();
    if (data?.Status?.toLowerCase() !== 'full') {
      setYesUrl(data.Category);
      setNoUrl(data.Category);
      setSelectedProg(data);
    }
  };

  const emptySelection = () => {
    setYesUrl('');
    setNoUrl('');
    setSelectedProg(null);
  };

  const gtmClick = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'EoE_Register_Now',
        IE_status: isIeDone ? 'Yes' : 'No',
        IE_Lang: 'en',
        city: 'Toronto',
      });

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: '',
          value: '',
          items: [
            {
              item_id: selectedProg?.Category, // id of the program
              item_name: 'Ecstasy of Enlightenment', // Name of the program (Ex - EoE)
              affiliation: '',
              coupon: '',
              discount: '',
              index: '',
              item_brand: isIeDone ? 'Yes' : 'No', //IE Status <Yes/No>
              item_category: 'EN', //IE Lang (User selected IE Language Ex- MR,EN,HI)
              item_category2: '',
              item_category3: '',
              item_category4: '',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: 'Toronto',
              price: '',
              quantity: '',
            },
          ],
        },
      });
    }
  };

  const cardStyle = {
    Open: {
      boxShadow: '0 0 2px #979797',
      background: '#FFFFFF',
    },
    Selected: {
      boxShadow:
        '0px 0px 0px 2px #be3a1d,3.06087px 18.7518px 41px rgba(34, 30, 2, 0.08), 1.98389px 12.154px 24.0116px rgba(34, 30, 2, 0.0607407), 1.179px 7.22293px 13.0593px rgba(34, 30, 2, 0.0485926), 0.612173px 3.75037px 6.6625px rgba(34, 30, 2, 0.04), 0.249404px 1.52793px 3.34074px rgba(34, 30, 2, 0.0314074), 0.0566827px 0.347256px 1.61343px rgba(34, 30, 2, 0.0192593)',
      background: '#F5F0E5',
    },
    Full: {
      outline: 'none',
      boxShadow: 'none',
      background: '#F5F0E5',
    },
  };

  const sectionIndexMap = {
    yes: {
      Philadelphia: 44,
      Toronto: 36,
      'San Francisco': 55,
    },
    no: {
      Philadelphia: 45,
      Toronto: 34,
      'San Francisco': 56,
    },
  };

  const index = sectionIndexMap[selTab]?.[selCity] ?? 0;
  return (
    <Box backgroundColor="#fff">
      <Box w="100%" maxW="1170px" mx="auto">
        {selTab === 'no' &&
          (selCity === 'Toronto' ||
            selCity === 'Philadelphia' ||
            selCity === 'San Francisco') && (
            <>
              {searchByFieldId(sectionContent, 'black-msg-no-toronto') &&
                selCity !== 'Toronto' && (
                  <Box
                    color="#000000"
                    fontFamily="FedraSansStd-book"
                    fontSize={{ base: '12px', md: '14px', lg: '14px' }}
                    fontWeight={600}
                    pt={{ base: '10px', md: '20px', lg: '20px' }}
                    pb="10px"
                    px={{ base: '15px', md: '0px', lg: '30px' }}
                    textAlign="center"
                    maxW={{ base: '100%', md: '80%', lg: '720px' }}
                    mx="auto"
                  >
                    {
                      searchByFieldId(sectionContent, 'black-msg-no-toronto')
                        .text
                    }
                  </Box>
                )}
              {torontoUrl &&
                searchByFieldId(sectionContent, 'no-regn-toronto-closed') && (
                  <>
                    <Box width={{ base: '100%', md: '60%' }} m={'0 auto'}>
                      <StructuredTextParser
                        str={render(
                          searchByFieldId(
                            sectionContent,
                            'no-regn-toronto-closed'
                          ).body
                        )}
                        region={region}
                        lang={lang}
                        fontFamily="FedraSansStd-book"
                        textAlign="center"
                        color="#000000"
                        fontSize={{base:'16px', md:'18px'}}
                      />
                    </Box>
                  </>
                )}
              {!torontoUrl && (
                <>
                  {searchByFieldId(
                    sectionContent,
                    'black-msg-no-toronto-online'
                  ) &&
                    selCity === 'Toronto' && (
                      <Box
                        color="#000000"
                        fontFamily="FedraSansStd-book"
                        fontSize={{ base: '12px', md: '14px', lg: '14px' }}
                        fontWeight={600}
                        pt={{ base: '10px', md: '20px', lg: '20px' }}
                        pb="10px"
                        px={{ base: '15px', md: '0px', lg: '30px' }}
                        textAlign="center"
                        maxW={{ base: '100%', md: '80%', lg: '720px' }}
                        mx="auto"
                      >
                        {
                          searchByFieldId(
                            sectionContent,
                            'black-msg-no-toronto-online'
                          ).text
                        }
                      </Box>
                    )}
                  <Grid pt={{ base: '15px', md: '30px', lg: '30px' }}>
                    <FormControl w={{ base: '100%', md: '762px' }} m="0 auto">
                      <RadioGroup value={IESelectedProg}>
                        <Flex
                          placeContent="center"
                          gridGap={{ base: '7px', md: '30px' }}
                          gridRowGap={{ base: '15px', md: '30px' }}
                          flexWrap="wrap"
                          flexDirection="row"
                          justifyContent={'center'}
                        >
                          {sectionContent[52]?.data?.map((data, i) => {
                            return (
                              <Box
                                as="label"
                                key={nanoid(4)}
                                w={{ base: '40%', md: '279px', lg: 'auto' }}
                                minW={{ base: '100%', md: '75%', lg: '160px' }}
                                paddingLeft={{
                                  base: '12.14px',
                                  md: '21.18px',
                                }}
                                display={
                                  torontoUrl == true && data.type == 'In Person'
                                    ? 'none'
                                    : 'block'
                                }
                                pr={{ base: '11.47px', md: '20px' }}
                                pt={{ base: '16.5px', md: '20px' }}
                                pb={{ base: '19px', md: '20px' }}
                                height="auto"
                                style={
                                  data?.type === IESelectedProg
                                    ? cardStyle.Selected
                                    : data?.type === IESelectedProg
                                    ? cardStyle.Full
                                    : cardStyle.Open
                                }
                                position="relative"
                                borderRadius="10px"
                                onClick={event =>
                                  handleIEProgramRadio(event, data)
                                }
                                cursor={
                                  data?.type === IESelectedProg
                                    ? 'cursor'
                                    : 'pointer'
                                }
                              >
                                <style>
                                  {`
                                .radio{
                                  border:0 !important;
                                  background:transparent !important;
                                }
                                .radio:before{
                                  background:#CF4520 !important;
                                }
                                `}
                                </style>
                                <Flex justifyContent="space-between">
                                  <Box
                                    fontFamily="FedraSansStd-medium"
                                    fontStyle="normal"
                                    fontWeight="500"
                                    fontSize={{ md: '20px', base: '14px' }}
                                    lineHeight="16px"
                                    display="flex"
                                    alignItems="center"
                                    fontFeatureSettings="case"
                                    color="#303030"
                                    marginRight={{ base: '20px', md: '20px' }}
                                  >
                                    {data.Category}
                                  </Box>
                                  <Radio
                                    name={`${selCity}_${data.Category}`}
                                    id="radio1"
                                    className="radio"
                                    colorScheme="orange"
                                    value={data.type}
                                    boxShadow="0 0 0 1px #CF4520"
                                    width="26px"
                                    height="26px"
                                    key={data.RefName}
                                    cursor="pointer"
                                    isDisabled={
                                      data?.type === IESelectedProg
                                        ? true
                                        : false
                                    }
                                  />
                                </Flex>
                                {data?.EBText && (
                                  <Box
                                    color={'#820000'}
                                    mt={'12px'}
                                    mr={{ base: '20px', md: '100px' }}
                                    fontFamily="FedraSansStd-book"
                                    fontStyle={'italic'}
                                    fontSize={{ base: '10.46px', md: '14px' }}
                                  >
                                    {data.EBText}
                                  </Box>
                                )}

                                <Box
                                  mt={'12px'}
                                  mr={{ base: '20px', md: '100px' }}
                                >
                                  <UnorderedList
                                    fontStyle="normal"
                                    fontWeight="400"
                                    fontSize={{ md: '16px', base: '10px' }}
                                    lineHeight={{ md: '20px', base: '16px' }}
                                    fontFeatureSettings="case"
                                    color="#28231E"
                                    fontFamily="FedraSansStd-book"
                                  >
                                    {data.Descripton.value_1 && (
                                      <ListItem mb="10px">
                                        {parser(data.Descripton.value_1 || '')}
                                      </ListItem>
                                    )}
                                    {data.Descripton.value_2 && (
                                      <ListItem mb="10px">
                                        {parser(data.Descripton.value_2 || '')}
                                      </ListItem>
                                    )}
                                    {data.Descripton.value_3 && (
                                      <ListItem mb="10px">
                                        {parser(data.Descripton.value_3 || '')}
                                      </ListItem>
                                    )}
                                    {data.Descripton.value_4 && (
                                      <ListItem mb="10px">
                                        {parser(data.Descripton.value_4 || '')}
                                      </ListItem>
                                    )}
                                  </UnorderedList>
                                </Box>
                              </Box>
                            );
                          })}
                        </Flex>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </>
              )}

              {!torontoUrl &&
                searchByFieldId(sectionContent, 'select-category-msg-no') && (
                  <Box
                    color="#000000"
                    fontFamily="FedraSansStd-book"
                    fontSize="18px"
                    fontWeight={600}
                    py={{ base: '40px', md: '40px', lg: '20px' }}
                    pb={{ base: '5px', md: '20px', lg: '20px' }}
                    px={{ base: '15px', md: '30px' }}
                    // fontStyle="italic"
                    textAlign="center"
                    maxW="720px"
                    mx="auto"
                  >
                    {
                      searchByFieldId(sectionContent, 'select-category-msg-no')
                        .text
                    }
                  </Box>
                )}
            </>
          )}
        {((selCity === 'Toronto' && selTab === 'yes') ||
          selCity === 'Philadelphia' ||
          selCity === 'San Francisco') && (
          <>
            {/* {selCity === 'Toronto' || (config.ENV_NAME !== 'production' && (selCity === 'Philadelphia' || selCity === 'San Francisco')) && (<> */}
            <Box maxW="590px" mx="auto" mt="25px">
              <SingleImage
                sectionContent={sectionContent[33]}
                region={region}
                lang={lang}
                px="0"
                style={{
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
                sync={true}
              />
              <Grid pt="30px">
                <FormControl>
                  <RadioGroup
                    // onChange={event => setNoUrl(event.target.value)}
                    // value={noUrl}
                    value={selTab === 'yes' ? yesUrl : noUrl}
                    onChange={event =>
                      selTab === 'yes'
                        ? setYesUrl(event.target.value)
                        : setNoUrl(event.target.value)
                    }
                  >
                    <Flex
                      placeContent="center"
                      gridGap={{ base: '7px', md: '30px' }}
                      gridRowGap={{ base: '15px', md: '30px' }}
                      mt="10px"
                      maxW="700px"
                      flexWrap="wrap"
                      flexDirection="row"
                    >
                      {sectionContent[index]?.data?.map((data, i) => {
                        if (data?.type === IESelectedProg || !data.type) {
                          return (
                            <Box
                              as="label"
                              key={nanoid(4)}
                              w={{ base: '40%', md: '279px' }}
                              maxW="279px"
                              minW={{ base: '47%', md: '160px' }}
                              minH={{ base: '160px', md: '250px' }}
                              paddingLeft={{
                                base: '12.14px',
                                md: '21.18px',
                              }}
                              pr={{ base: '11.47px', md: '20px' }}
                              pt={{ base: '16.5px', md: '29px' }}
                              pb={{ base: '19px', md: '27px' }}
                              style={
                                yesUrl === data.Category
                                  ? cardStyle.Selected
                                  : data?.Status?.toLowerCase() === 'full'
                                  ? cardStyle.Full
                                  : cardStyle.Open
                              }
                              position="relative"
                              borderRadius="10px"
                              onClick={event => handleRadioClick(event, data)}
                              cursor={
                                data?.Status?.toLowerCase() === 'full'
                                  ? 'cursor'
                                  : 'pointer'
                              }
                            >
                              {data?.Status?.toLowerCase() === 'full' && (
                                <Box
                                  pos="absolute"
                                  top={0}
                                  right={0}
                                  left={0}
                                  bottom={0}
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  textAlign="center"
                                  background="#494949"
                                  opacity="0.7"
                                  borderRadius="10px"
                                >
                                  <Text
                                    color="#fff"
                                    fontSize="24px"
                                    fontFamily="FedraSansStd-medium"
                                  >
                                    FULL
                                  </Text>
                                </Box>
                              )}
                              <style>
                                {`
                                  .radio{
                                    border:0 !important;
                                    background:transparent !important;
                                  }
                                  .radio:before{
                                    background:#CF4520 !important;
                                  }
                                  `}
                              </style>
                              <Flex justifyContent="space-between">
                                <Box
                                  fontFamily="FedraSansStd-medium"
                                  fontStyle="normal"
                                  fontWeight="500"
                                  fontSize={{ md: '20px', base: '14px' }}
                                  lineHeight="22px"
                                  display="flex"
                                  alignItems="center"
                                  fontFeatureSettings="case"
                                  color="#000000"
                                >
                                  {data.Category}
                                </Box>
                                <Radio
                                  name={`${selCity}`}
                                  id="radio1"
                                  className="radio"
                                  colorScheme="orange"
                                  value={data.Category}
                                  boxShadow="0 0 0 1px #CF4520"
                                  width="20px"
                                  height="20px"
                                  key={data.RefName}
                                  cursor="pointer"
                                  isDisabled={
                                    data?.Status?.toLowerCase() === 'full'
                                      ? true
                                      : false
                                  }
                                />
                              </Flex>
                              {data?.EBText && (
                                <Box
                                  color={'#B40000'}
                                  fontFamily="FedraSansStd-book"
                                  fontSize={{ base: '10.46px', md: '18px' }}
                                >
                                  {data.EBText}
                                </Box>
                              )}
                              <Box
                                fontFamily="FedraSansStd-book"
                                background="#E4DED4"
                                borderRadius="4px"
                                p={{ sm: '4px 12px', base: '5px' }}
                                fontSize={{ md: '18px', base: '10.5px' }}
                                mt="10px"
                                mb={'20px'}
                                color="#000"
                                textAlign="left"
                                w="auto"
                                display="inline-flex"
                              >
                                {data.NormalPrice !== data.EBPrice && (
                                  <Box
                                    as="span"
                                    textDecoration="line-through"
                                    mr={{ base: '5px', md: '10px' }}
                                  >
                                    {data.NormalPrice}
                                  </Box>
                                )}

                                {data.EBPrice}
                              </Box>

                              <Box>
                                <UnorderedList
                                  fontStyle="normal"
                                  fontWeight="400"
                                  fontSize={{ md: '16px', base: '10px' }}
                                  lineHeight={{ md: '20px', base: '16px' }}
                                  fontFeatureSettings="case"
                                  color="#28231E"
                                  fontFamily="FedraSansStd-book"
                                >
                                  {data.Descripton.value_1 && (
                                    <ListItem mb="10px">
                                      {parser(data.Descripton.value_1 || '')}
                                    </ListItem>
                                  )}
                                  {data.Descripton.value_2 && (
                                    <ListItem
                                      mb={{
                                        base: '0px',
                                        lg: '10px',
                                        md: '10px',
                                      }}
                                    >
                                      {parser(data.Descripton.value_2 || '')}
                                    </ListItem>
                                  )}
                                  {data.Descripton.value_3 && (
                                    <ListItem mb="10px">
                                      {parser(data.Descripton.value_3 || '')}
                                    </ListItem>
                                  )}
                                </UnorderedList>
                              </Box>
                            </Box>
                          );
                        }
                      })}
                    </Flex>
                  </RadioGroup>
                </FormControl>
              </Grid>

              {searchByFieldId(sectionContent, 'yes-price-include-toronto') && (
                <StructuredTextParser
                  str={render(
                    searchByFieldId(sectionContent, 'yes-price-include-toronto')
                      .body
                  )}
                  region={region}
                  lang={lang}
                  fontFamily="FedraSansStd-book"
                  textAlign="center"
                  pt="60px"
                  fontSize="16px"
                  mt="0px"
                  color="#28231E"
                />
              )}
              {!isIeDone &&
                searchByFieldId(sectionContent, 'no-price-include-toronto') && (
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(
                        sectionContent,
                        'no-price-include-toronto'
                      ).body
                    )}
                    region={region}
                    lang={lang}
                    fontSize="16px"
                    fontStyle="italic"
                    fontFamily="FedraSansStd-book"
                    py="15px"
                    color="#303030"
                    px="15px"
                  />
                )}
              {sectionContent[28]?._modelApiKey === 'simple_button' && (
                <Box display="flex" placeContent="center" mt="10px">
                  {/* <Link
                href={
                  selectedProg?.LinkUrl
                    ? refineUrlDomain(
                        `${
                          selectedProg?.LinkUrl
                        }?seat=${noUrl}&package=${!isIeDone}`,
                        region,
                        lang
                      )
                    : 'javascript:void()'
                }
                disabled={!yesUrl}
                py="40px"
                display="block"
                fontWeight={'500'}
                fontFamily={'FedraSansStd-medium'}
                fontSize={'18px'}
                bgColor={yesUrl ? '#CF4520' : '#333333'}
                opacity={yesUrl ? '1' : '0.4'}
                h={'auto'}
                minH="50px"
                textAlign="left"
                padding={'14px 29px'}
                borderRadius="5px"
                color="#faf7f0"
                textDecoration="none"
                width={'auto'}
                cursor={yesUrl ? 'pointer' : 'not-allowed'}
                _hover={{
                  background: yesUrl ? '#000054' : '#333333',
                }}
                target={yesUrl ? '_blank' : ''}
                onClick={() => {
                  gtmClick();
                }}
              >
                {selectedProg?.CTAButton || sectionContent[28]?.buttonText}
              </Link> */}
                  {selTab === 'yes' && (
                    <Link
                      href={
                        selectedProg?.LinkUrl
                          ? refineUrlDomain(
                              selectedProg?.LinkUrl +
                                `?seat=${yesUrl}&package=${0}` ||
                                sectionContent[17]?.linkUrl +
                                  `?seat=${yesUrl}&package=${0}`,
                              region,
                              lang
                            )
                          : 'javascript:void()'
                      }
                      mb="20px"
                      display="block"
                      fontWeight={'500'}
                      fontFamily={'FedraSansStd-medium'}
                      fontSize={'18px'}
                      bgColor={yesUrl ? '#CF4520' : '#333333'}
                      opacity={yesUrl ? '1' : '0.4'}
                      h={'auto'}
                      minH="50px"
                      textAlign="left"
                      padding={'14px 29px'}
                      borderRadius="5px"
                      color="#faf7f0"
                      textDecoration="none"
                      width={'auto'}
                      cursor={yesUrl ? 'pointer' : 'not-allowed'}
                      _hover={{
                        background: yesUrl ? '#000054' : '#333333',
                      }}
                      target={yesUrl ? '_blank' : ''}
                      onClick={() => {
                        gtmClick();
                      }}
                    >
                      {selectedProg?.CTAButton ||
                        sectionContent[28]?.buttonText}
                    </Link>
                  )}
                  {selTab === 'no' && (
                    <Link
                      href={
                        selectedProg?.LinkUrl
                          ? refineUrlDomain(
                              `${selectedProg?.LinkUrl}?seat=${
                                noUrl?.trim().split(' ')[0]
                              }&package=${
                                IESelectedProg === 'In Person' ? 2 : 1
                              }`,
                              region,
                              lang
                            )
                          : 'javascript:void()'
                      }
                      my="30px"
                      display="block"
                      fontWeight={'500'}
                      fontFamily={'FedraSansStd-medium'}
                      fontSize={'18px'}
                      bgColor={noUrl ? '#cf4520' : '#cf452069'}
                      h={'auto'}
                      minH="50px"
                      textAlign="left"
                      padding={'14px 29px'}
                      borderRadius="5px"
                      color="#faf7f0"
                      textDecoration="none"
                      width={'auto'}
                      cursor={noUrl ? 'pointer' : 'not-allowed'}
                      _hover={{
                        bg: noUrl ? '#000054' : '',
                      }}
                      target={noUrl ? '_blank' : ''}
                      onClick={() => {
                        gtmClick();
                      }}
                    >
                      {selectedProg?.CTAButton ||
                        sectionContent[28]?.buttonText}
                    </Link>
                  )}
                </Box>
              )}

              {searchByFieldId(sectionContent, 'translation-toronto') && (
                <StructuredTextParser
                  str={render(
                    searchByFieldId(sectionContent, 'translation-toronto').body
                  )}
                  region={region}
                  lang={lang}
                  fontSize="16px"
                  fontStyle="italic"
                  fontFamily="FedraSansStd-book"
                  py="5px"
                  color="#303030"
                  px="15px"
                />
              )}
            </Box>
          </>
        )}
        {/* {(selCity === 'Philadelphia' || selCity === 'San Francisco') && sectionContent[57]?._modelApiKey === 'simple_button' && (
          <>
          <Box display="flex" placeContent="center" mt="10px">
            <Link
              href={sectionContent[57]?.linkUrl ? refineUrlDomain(
                sectionContent[57].linkUrl,
                region,
                lang
              ) : 'javascript:void()'}
              my="30px"
              display="block"
              fontWeight={'500'}
              fontFamily={'FedraSansStd-medium'}
              fontSize={'18px'}
              bgColor={'#cf4520'}
              h={'auto'}
              minH="50px"
              textAlign="left"
              padding={'14px 29px'}
              borderRadius="5px"
              color="#faf7f0"
              textDecoration="none"
              width={'auto'}
              cursor={'pointer'}
              _hover={{
                bg: '#000054',
              }}
              target={'_blank'}
            >
              {selectedProg?.CTAButton || sectionContent[57]?.buttonText}
            </Link>
            </Box>
          </>
        )} */}
      </Box>
      <style jsx global>
        {`
          .textParagraph p {
            font-size: 18px;
            color: #be3a1d;
            text-transform: uppercase;
          }
          .textParagraph p:nth-child(2) {
            font-size: 16px;
            color: #28231e;
            text-transform: none;
            font-family: 'FedraSansStd-book';
          }
          @media only screen and (max-width: 360px) {
            .gridComponent {
              grid-template-columns: repeat(1, minmax(0, 1fr));
              margin-top: 10px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default FourCardsToronto;
